export default __webpack_public_path__ + "static/media/f2.e812b2d0.jpg";